// @ts-nocheck
import { useState, useEffect, useRef } from "react";
import { Button, Input, Form, Select, Flex } from 'antd';
import AdminDashboard from "./admin-dashboard";

const secretKey = "dumbsecretkey"
const storage = {
  getUserToken: async () => {
    await new Promise(resolve => setTimeout(resolve, 400));
    return "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOjEyMywiaXNBZG1pbiI6ZmFsc2UsImV4cCI6MTc3ODY4MTg5OH0.uB4WJeH_nn1yN9jdx_HzWzTL8wsbqEI3h_1GXAL61L8" // false
    //return "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOjEyMywiaXNBZG1pbiI6dHJ1ZSwiZXhwIjoxNzc4NjgxOTE1fQ.Ksi7OCCsSeHsLuwvL6JXhCTjjTvLxp5Ue8KyIrj6CVA" // true
  }
}
const base64urlDecode = (str: any) => {
  str = str.replace(/-/g, "+").replace(/_/g, "/");
  const pad = str.length % 4 ? 4 - (str.length % 4) : 0;
  const base64 = str + "=".repeat(pad);
  const bin = atob(base64);

  const bytes = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
  return bytes.buffer;
}


async function verifyAndParseToken(storageFunction) {
  const token = await storage[storageFunction]();
  const [, payloadB64] = token.split(".");
  const payload = JSON.parse(new TextDecoder().decode(base64urlDecode(payloadB64)));

  if (payload.exp && Date.now() / 1000 > payload.exp) {
    throw new Error("Token expired");
  }
  return payload;
}

async function getUserRole() {
  const payload = await verifyAndParseToken("getUserToken");
  return payload.isAdmin ? "admin" : "user";
}

const Admin = () => {
  const [isAdmin, setIsAdmin] = useState(null);

  const verify = async (values: any) => {
    const v = await getUserRole();
    setIsAdmin(v === "admin")
  };

  if (isAdmin === true) {
    return <AdminDashboard />
  }

  return (
    <div className="h-full overflow-auto">
      {isAdmin === false && <h2 style={{ color: "red" }}>You must be and admin</h2>}
      <Button onClick={verify}>
        Goto Admin Dashboard
      </Button>
    </div>

  );
}



export default Admin;